


































































import TableColumnManager from '@/general/component/table/TableColumnManager.vue';
import Component from 'vue-class-component';
import Vue from 'vue';
import { AxiosResponse } from 'axios';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import TooltipIcon from '@/general/component/tooltip-icon/TooltipIcon.vue';
import ModelAutocomplete from '@/general/component/form/autocomplete/ModelAutocomplete.vue';
import LocationAutocomplete from '@/general/component/form/autocomplete/LocationAutocomplete.vue';
import { notNullOrUndefinedOrBlank } from '@/utility/functions';
import { ConfirmationDialogType, TableOptions, UrlQuery } from '@/general/custom-types/CustomTypes';
import ConfirmationDialog from '@/general/component/ConfirmationDialog.vue';
import Router from '@/common/router/Router';
import { Filter } from '@/common/model/Filter';
import { Api } from '@/common/api/Api';
import { Debounce } from 'vue-debounce-decorator';
import { filteringDebounceTime } from '@/utility/constants';
import ItemPredicate from "@/common/model/ItemPredicate";

@Component({
  components: {
    ConfirmationDialog,
    LocationAutocomplete,
    ModelAutocomplete,
    TooltipIcon,
    TableColumnManager
  }
})
export default class PageContainer extends Vue {
  models: Array<Record<string, unknown>> = [];
  totalElements: number = -1;
  @Prop({
    default: [
      {
        text: "Id",
        value: "id",
        align: "left"
      },
      {
        text: "Operacje",
        value: "actions",
        align: "left"
      }
    ]
  })
  commonHeaders!: Array<Record<string, unknown>>;

  @Prop({ default: [] }) entityHeaders!: Array<Record<string, unknown>>;
  options: TableOptions = {
    page: 0,
    itemsPerPage: 100,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: true,
    mustSort: false
  };
  pageSizes: Array<number> = [50, 100, 200];
  loading: boolean = true;
  @Ref("confirmationDialog") confirmationDialog!: ConfirmationDialogType;
  @Prop() router!: Router;
  // TODO: to filter mozna otypowac na jakos <? extends Filter>
  @Prop() filter!: Filter;
  @Prop({ default: true }) showVisible!: boolean;
  @Prop({ default: false }) showDisabled!: boolean;
  @Prop({ default: true }) editVisible!: boolean;
  @Prop({ default: false }) editDisabled!: boolean;
  @Prop({ default: true }) deleteVisible!: boolean;
  @Prop({ default: false }) deleteDisabled!: boolean;
  @Prop({ default: true }) deactivateVisible!: boolean;
  @Prop({ default: false }) deactivateDisabled!: boolean;
  @Prop({ default: false }) defaultSortById!: boolean;
  @Prop() api!: Api;
  @Prop() deleteItemPredicate!: ItemPredicate;

  async created(): Promise<void> {
    this.loadOptionsFromUrl();
    //this.loadFilterFromUrl();
    this.loadFilterFromLocalStorage();
    if(this.defaultSortById){
      this.options.sortBy = ['id']
      this.options.sortDesc = [true];
    }
  }

  async fetch(): Promise<void> {
    this.loading = true;
    const queryParam: string = this.buildQueryParam();
    const response: AxiosResponse = await this.api.findPage(queryParam);
    this.totalElements = response.data.page.totalElements;
    this.models = response.data.page.content;
    this.loading = false;
  }

  get headers(): Array<Record<string, unknown>> {
    const headers: Array<Record<string, unknown>> = [
      this.commonHeaders[0],
      ...this.entityHeaders,
      this.commonHeaders[1]
    ];
    return headers;
  }

  buildQueryParam(): string {
    let query: string = "page=" + this.options.page + "&size=" + this.options.itemsPerPage;
    const sortFieldAmount: number = this?.options?.sortBy?.length ? this.options.sortBy.length : 0;
    if (sortFieldAmount != 0) {
      for (let i = 0; i < sortFieldAmount; i++) {
        const order: string = this.options.sortDesc[i] ? "DESC" : "ASC";
        query = query + "&sort=" + this.options.sortBy[i].toString() + "," + order;
      }
    }
    query = this.buildFilterQueryParam(query);
    return query;
  }

  loadFilterFromUrl(): void {
    const filterQuery: string | (string | null)[] = this.$route?.query?.filter;
    //TODO: znalezc lepszy sposob na to zapis/odczyt z urla, bo json to slaba opcja albo to chociaz kodowac
    const filterUrl: string = typeof filterQuery === "string" ? filterQuery.toString() : "";
    if (notNullOrUndefinedOrBlank(filterUrl)) {
      const filter: Record<string, unknown> = JSON.parse(filterUrl);
      this.filter.copyInto(filter);
    }
  }

  loadOptionsFromUrl(): void {
    const optionsQuery: string | (string | null)[] = this.$route?.query?.options;
    //TODO: znalezc lepszy sposob na to zapis/odczyt z urla, bo json to slaba opcja albo to chociaz kodowac
    const optionsUrl: string = typeof optionsQuery === "string" ? optionsQuery.toString() : "";
    if (notNullOrUndefinedOrBlank(optionsUrl)) {
      const options: TableOptions = JSON.parse(optionsUrl);
      this.options = options;
    }
  }

  private loadFilterFromLocalStorage() {
    const maybeFilter = window.localStorage.getItem(this.filter.getFilterName());
    if (maybeFilter) {
      this.filter.copyInto(JSON.parse(maybeFilter));
    }
  }
  private saveFilterToLocalStorage() {
    window.localStorage.setItem(this.filter.getFilterName(), JSON.stringify(this.filter));
  }

  updateFilterToUrl(): void {
    const filter: string = JSON.stringify(this.filter);
    let query: UrlQuery = this.loadRouteQuery();
    query.filter = filter;
    this.updateUrlQuery(query);
  }

  updateOptionsToUrl(): void {
    const options: string = JSON.stringify(this.options);
    let query: UrlQuery = this.loadRouteQuery();
    query.options = options;
    this.updateUrlQuery(query);
  }

  updateUrlQuery(query: UrlQuery): void {
    // TODO: Niestety trzeba try catchowac. Mozna to ominac zmieniajac mode routera na history, a linijke this.router.replace zamieniajac na window.history.pushstate
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this.$router.replace({ query: query }).catch(() => {});
  }

  loadRouteQuery(): UrlQuery {
    let query: UrlQuery = Object.assign({}, this.$route.query);
    return query;
  }

  @Debounce(filteringDebounceTime)
  @Watch("options", {
    deep: true,
    immediate: false
  })
  async onOptionsChanged(): Promise<void> {
    this.updateOptionsToUrl();
    await this.fetch();
  }

  @Debounce(filteringDebounceTime)
  @Watch("filter", {
    deep: true,
    immediate: false
  })
  async onFilterChanged(): Promise<void> {
    this.updateFilterToUrl();
    this.saveFilterToLocalStorage();
    await this.fetch();
  }

  clearFilter() {
    window.localStorage.removeItem(this.filter.getFilterName());
    this.filter.clear();
  }

  buildFilterQueryParam(query: string): string {
    query = query + "&" + this.filter.toQueryParam();
    return query;
  }

  goToShow(id: number) {
    const route: Record<string, unknown> = this.router.show(id);
    this.$router.push(route);
  }

  goToUpdate(id: number) {
    const route: Record<string, unknown> = this.router.update(id);
    this.$router.push(route);
  }

  async deleteItem(id: number): Promise<void> {
    const confirmation: boolean = await this.confirmationDialog.open(
      "Usuwanie",
      "Czy jesteś pewien, że chcesz usunąć element?",
      { color: "red" }
    );
    if (confirmation) {
      try{
        await this.api.delete(id);
        await this.fetch();
        this.confirmationDialog.close();
      } catch (e) {
        this.confirmationDialog.close();
        alert(e.response.data.message)
      }
    }
  }

  async deactivateItem(id: number): Promise<void> {
    const confirmation: boolean = await this.confirmationDialog.open(
      "Dezaktywacja",
      "Czy jesteś pewien, że chcesz dezaktywować element?",
      { color: "red" }
    );
    if (confirmation) {
      await this.api.deactivate(id);
      await this.fetch();
      this.confirmationDialog.close();
    }
  }

  isDeleteDisabled(item: Record<string, unknown>): boolean{
    if(this.deleteDisabled){
      return true;
    }
    if(this.deleteItemPredicate != undefined){
      type ObjectKey = keyof typeof item;
      return item[this.deleteItemPredicate.itemProperty as ObjectKey]
        === this.deleteItemPredicate.expectedValue;
    }
    return false;
  }
}
